import { NodeType } from "../../PipelineBuilderV2/Models/NodeType";

import { usePipelineBuilder } from "V2.0/HomePages/Pipelines/PipelineBuilder/PipelineBuilderProvider";

import AssistantExecution from "./Assistant";
import ConditionalExecution from "./Conditional";
import ExternalApiExecution from "./ExternalApi";
import WebhookTriggerExecution from "./WebhookTrigger";
import EndExecution from "./End";
import DelayExecution from "./Delay";

export default NodeExecution;

const NodeExecutionRegistry = {
  [NodeType.WEBHOOK_TRIGGER]: WebhookTriggerExecution,
  [NodeType.ASSISTANT]: AssistantExecution,
  [NodeType.CONDITIONAL]: ConditionalExecution,
  [NodeType.EXTERNAL_API]: ExternalApiExecution,
  [NodeType.DELAY]: DelayExecution,
  [NodeType.END]: EndExecution,
};

function NodeExecution() {
  const { panel, closePanel, workspaceId } = usePipelineBuilder();

  const node = panel.node;

  const Execution = NodeExecutionRegistry[node.type];

  return (
    <Execution
      node={node}
      closePanel={closePanel}
      workspaceId={workspaceId}
      nodeExecution={panel.nodeExecution}
    />
  );
}
